import * as angular from 'angular';
import './styling.scss';
import * as template from './template.html';
import { CurrentUserService } from 'services/currentUser';

const module = angular.module('greeting', []);

interface GreetingController extends angular.IStrictController {
    firstName: string;
    earliestPolicyYear: string;
}

module.component('greeting', {
    template: template,
    controller: function(this: GreetingController, currentUserService: CurrentUserService) {
        'ngInject';

        this.$onInit = () => {
            currentUserService.firstName().then((firstName) => {
                this.firstName = firstName;
            });

            currentUserService.earliestPolicyYear().then((earliestPolicyYear) => {
                this.earliestPolicyYear = earliestPolicyYear;
            });
        };
    }
});

export { module };
